const  couponBadges = document.querySelectorAll('.coupon-badge');
if(couponBadges){
  couponBadges.forEach((badge => {
    badge.addEventListener('click',function(){
      if(this.dataset.text_offer != null){
        const texto =this.dataset.text_offer;
        var selectorSpan = this.querySelector('.data-badge')
        var originalText = selectorSpan.textContent;
        const regex = /\[(.*?)\]/;
        var match = texto.match(regex);
        if (match) {
          const codigo = match[1];
          navigator.clipboard.writeText(codigo)
            .then(function() {
              console.log("Texto copiado al portapapeles.");
              //showAlert('¡Copiado!',1000);
             selectorSpan.innerText = "¡Copiado!";
              setTimeout(() => {
                selectorSpan.innerText = originalText;
              }, "1000");
             
            })
            .catch(function(error) {
              console.error("Error al copiar el texto al portapapeles: ", error);
              });
          } else {
            console.log("Code not found");
          }
        }
      });
    }));  
}

      /*const simuladorStockElement = document.getElementById('s-stock-cantidad');
      let simuladorStock = localStorage.getItem('simuladorStock');
      if (simuladorStock === null) {
          simuladorStock = 30;
      } else {
          simuladorStock = parseInt(simuladorStock, 10);
      }
      simuladorStockElement.textContent = simuladorStock;

      function actualizarStock() {
          const cantidadAleatoria = Math.floor(Math.random() * 2) + 1;
          simuladorStock -= cantidadAleatoria;
          if (simuladorStock <= 0) {
              simuladorStock = 30;
          }
          simuladorStockElement.textContent = simuladorStock;
          localStorage.setItem('simuladorStock', simuladorStock);
      }
      setInterval(actualizarStock, 10000);*/
document.addEventListener("DOMContentLoaded", () => {

  const link = document.querySelector('#promoBar a');
  console.log(link);
  if (!link) return;
  const dataContainer = link;
  const now = new Date();
  const idProduct = dataContainer.dataset.productid;
  const period = dataContainer.dataset.period;
  const timer = dataContainer.dataset.timer;
  const counter = dataContainer.dataset.counter;
  let targetDate;
  const storageKey = idProduct ? `${idProduct}_enddate` : null;
  function getNextBlockDate(baseDate) {
    const BLOCK_SIZE_HOURS = parseInt(period); 
    const BLOCK_START_HOUR = 18; 
    const current = new Date(baseDate);
    current.setSeconds(0, 0); 
    const hoursFromStart = ((current.getHours() - BLOCK_START_HOUR + 24) % 24);
    const blocksPassed = Math.floor(hoursFromStart / BLOCK_SIZE_HOURS);
    const nextBlockStartHour = (BLOCK_START_HOUR + (blocksPassed + 1) * BLOCK_SIZE_HOURS) % 24;
    const nextBlockDate = new Date(current);
    nextBlockDate.setHours(nextBlockStartHour, 0, 0, 0);
    if (nextBlockStartHour <= current.getHours()) {
      nextBlockDate.setDate(nextBlockDate.getDate() + 1);
    }
    return nextBlockDate;
  }
  if (period && idProduct) {
    const storedDate = localStorage.getItem(storageKey);
    if (storedDate && new Date(storedDate) > now) {
      targetDate = new Date(storedDate);
    } else {
      const nextBlock = getNextBlockDate(now);
      localStorage.setItem(storageKey, nextBlock.toISOString());
      targetDate = nextBlock;
    }
  } else {
    targetDate = counter
      ? new Date(counter)
      : new Date(now.getTime() + timer * 60 * 1000);
  }


  const elements = {
    days: document.getElementById("days"),
    hours: document.getElementById("hours"),
    minutes: document.getElementById("minutes"),
    seconds: document.getElementById("seconds")
  };
  function updateCountdown() {
    const now = Date.now();
    const timeLeft = targetDate - now;
    if (timeLeft <= 0) {
      if (period && idProduct) {
        const nextBlock = getNextBlockDate(new Date());
        localStorage.setItem(storageKey, nextBlock.toISOString());
        targetDate = nextBlock;
        return; 
      } else {
        document.querySelector('#promoBar').style.display = "none";
        clearInterval(interval);
        return;
      }
    } else {
      document.querySelector('#promoBar').style.display = "flex";
    }
    const timeUnits = {
      days: Math.floor(timeLeft / (1000 * 60 * 60 * 24)),
      hours: Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((timeLeft % (1000 * 60)) / 1000)
    };

    Object.keys(timeUnits).forEach(unit => {
      elements[unit].textContent = String(timeUnits[unit]).padStart(2, '0');
    });
  }
  updateCountdown();
  const interval = setInterval(updateCountdown, 1000);
});
